<ion-content class="ion-padding">
  <ion-header>
    <ion-toolbar>
      <ion-title>{{"Unsuccessful Payment" | translate}}</ion-title>
    </ion-toolbar>
  </ion-header>

  <div class="ion-text-center">
    <div class="wrapper">
      <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
        <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none" />
        <path class="checkmark__check checkmark__x" fill="none" d="M16 16, 36 36, M36 16, 16 36" />
      </svg>
    </div>
    <h1 class="ion-text-success">{{"Payment Failed"}}</h1>
    <p>{{"Your payment could not be processed."| translate}}</p>
    <p>{{"Your payment could not be processed. Please try again. Cotact us if the problem persists." | translate}}</p>

    <ion-button class="back-button" routerLink="/">{{"Back to Homepage" | translate}}</ion-button>
  </div>


</ion-content>